import PhoneInputWrapper from './PhoneInputWrapper';

export default PhoneInputWrapper;
